import { useEffect } from 'react';
import { useLogout } from 'react-admin';

import { createInactivityWatcher } from '@Utils/inactivity/createInactivityWatcher';

const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;

const BROADCAST_CHANNEL_NAME = 'bo_external_inactivity';

export const useInactivityLogout = () => {
  const logout = useLogout();

  useEffect(() => {
    const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);

    const watcher = createInactivityWatcher({
      timeoutMs: INACTIVITY_TIMEOUT_MS,
      onTimeout: () => {
        logout();
      },
      onActivity: () => {
        channel.postMessage('activity');
      },
    });

    channel.onmessage = () => {
      watcher.reset();
    };

    return () => {
      watcher.cleanup();
      channel.close();
    };
  }, [logout]);
};
